import { action_options, app_modules } from "helpers/apps_modules_list";
import Enquiry from "pages/Order/Enquiry/Enquiry";
import EnquiryCreateForm from "pages/Order/Enquiry/EnquiryCreateForm";
import EnquiryDetailsPage from "pages/Order/Enquiry/EnquiryDetailsPage";
import EnquiryEditFrom from "pages/Order/Enquiry/EnquiryEditForm";
import Sitevisit from "pages/Order/SiteVisit/SiteVisit";
import SiteVisitDetailsPage from "pages/Order/SiteVisit/SiteVisitDetailsPage";
import SiteVisitEditFrom from "pages/Order/SiteVisit/SiteVisitEditForm";
import EditOrderForm from "pages/Order/Order/Form/EditOrderForm/EditOrderForm";
import OrderForm from "pages/Order/Order/Form/OrderForm/OrderForm";
import QuotationOrderForm from "pages/Order/Order/Form/QuotationOrderForm/QuotationOrderForm";
import OrderList from "pages/Order/Order/List/Order";
import ViewOrderDetails from "pages/Order/Order/ViewDetails/ViewOrderDetails";
import QuotationIndex from "pages/Order/Quotation/Listing/index";
import QuotationCreateForm from "pages/Order/Quotation/QuotationCreateForm";
import QuotationDetailsPage from "pages/Order/Quotation/QuotationDetailsPage";
import QuotationEditForm from "pages/Order/Quotation/QuotationEditForm";
import CancelOrder from "pages/Order/Order/ViewDetails/CancelOrder";
import EnquiryQuotationForm from "pages/Order/Quotation/Form/EnquiryQuotationForm/EnquiryQuotationForm";
import QuotationDispatchForm from "pages/Order/Quotation/Form/DispatchForm/QuotationDispatchForm";
import QuotationDispatchEditForm from "pages/Order/Quotation/Form/DispatchForm/QuotationDispatchEditForm";

const OrderRoutes: any = [
  //*// New Routes Added Below //*//
  // Enquiry
  {
    path: "/enquiry",
    component: <Enquiry />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.enquiry,
      action: action_options?.view,
    },
  },

  // Enquiry Form
  {
    path: "/enquiry-form",
    component: <EnquiryCreateForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.enquiry,
      action: action_options?.create,
    },
  },

  // Enquiry Edit Form
  {
    path: "/enquiry-form/:id",
    component: <EnquiryEditFrom />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.enquiry,
      action: action_options?.update,
    },
  },

  // Enquiry Details Page
  {
    path: "/enquiry-details/:id",
    component: <EnquiryDetailsPage />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.enquiry,
      action: action_options?.view,
    },
  },

  // Quotation
  {
    path: "/quotation",
    component: <QuotationIndex />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.view,
    },
  },
  {
    path: "/quotation/create/:id",
    component: <EnquiryQuotationForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.create,
    },
  },
  {
    path: "/quotation/create",
    component: <QuotationCreateForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.create,
    },
  },
  {
    path: "/quotation/edit/:id",
    component: <QuotationEditForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.update,
    },
  },
  {
    path: "/quotation/view/:id",
    component: <QuotationDetailsPage />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.view,
    },
  },
  {
    path: "/quotation/create-dispatch/:quotation_id",
    component: <QuotationDispatchForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.view,
    },
  },
  {
    path: "/quotation/edit-dispatch/:quotation_id/dispatch_id",
    component: <QuotationDispatchEditForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.quotation,
      action: action_options?.view,
    },
  },

  // Sitevisit
  {
    path: "/sitevisit",
    component: <Sitevisit />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.site_visit,
      action: action_options?.view,
    },
  },

  {
    path: "/sitevisit-form",
    component: <EnquiryCreateForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.site_visit,
      action: action_options?.create,
    },
  },

  // Enquiry Edit Form
  {
    path: "/sitevisit-form/:id",
    component: <SiteVisitEditFrom />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.site_visit,
      action: action_options?.update,
    },
  },

  // Enquiry Details Page
  {
    path: "/sitevisit-details/:id",
    component: <SiteVisitDetailsPage />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.site_visit,
      action: action_options?.view,
    },
  },

  // Order
  {
    path: "/order-list",
    component: <OrderList />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.view,
    },
  },
  {
    path: "/add-order",
    component: <OrderForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.create,
    },
  },
  {
    path: "/add-quotation-order/:quotation_id",
    component: <QuotationOrderForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-order/:id",
    component: <EditOrderForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.update,
    },
  },
  {
    path: "/edit-quotation-order/:id/:quotation_id",
    component: <EditOrderForm />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.update,
    },
  },
  {
    path: "/view-order/:id",
    component: <ViewOrderDetails />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.view,
    },
  },
  {
    path: "/cancel-order/:id",
    component: <CancelOrder />,
    permissions: {
      app_name: app_modules.order.app_name,
      module_name: app_modules.order.modules.order,
      action: action_options?.update,
    },
  },
];

export default OrderRoutes;